/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazxl6c%7Bcolor%3Avar(--ds-icon-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1xb2%7Bdisplay%3Avar(--expandable-provided-elembefore-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%5Bdir%3Drtl%5D%20._1tz3r0mg%7Btransform%3AscaleX(-1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0ciw0t%7Bdisplay%3Avar(--expandable-chevron-display)%7D");
import React, { type ReactNode } from 'react';
import type { IconProps } from '@atlaskit/icon';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { chevronDisplayCssVar, providedElemBeforeDisplayCssVar } from '../../../../common/constants';
type ExpandableMenuItemIconProps = {
  isExpanded: boolean;
  isHovering: boolean;
  isSelected?: boolean;
  /**
   * The element to display when the user is not hovering over the icon. If not provided, the chevron icon will be used
   */
  providedElemBefore?: ReactNode;
  iconProps?: IconProps;
};
const iconStyles = {
  chevron: "_1e0ciw0t _1tz3r0mg",
  providedElemBefore: "_1e0c1xb2",
  providedElemBeforeSelected: "_syazxl6c"
};
export const ExpandableMenuItemIcon = ({
  iconProps,
  isExpanded,
  isSelected,
  providedElemBefore
}: Omit<ExpandableMenuItemIconProps, 'isHovering'>): JSX.Element => {
  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon;
  const chevronElem = <ChevronIcon {...iconProps} label="" color={isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined} size="small" />;
  return <React.Fragment>
			<div className={ax([iconStyles.chevron])}>{chevronElem}</div>
			{/* If there is no provided elemBefore, not rendering the wrapper either to simplify the DOM */}
			{providedElemBefore && <div className={ax([iconStyles.providedElemBefore, isSelected && iconStyles.providedElemBeforeSelected])}>
					{providedElemBefore}
				</div>}
		</React.Fragment>;
};